<body class="app header-fixed ">
 <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top" style="padding:0 !important;">
    <a class="navbar-brand" routerLink="" ><img src="https://vvdo-dev.vervendo.com/frontend/img/logo-2017-min.png" style="height: 70px;width:auto;"></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a class="nav-link disabled" href="#">My Dashboard</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" href="#">My Requests</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" href="#">My Bookings</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" href="#">My Settings</a>
        </li>
      </ul>
      <ul class="navbar-nav mr-auto" style="margin-right: 0 !important;">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Hi, username</a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#">Something else here</a>
          </div>
        </li>
        <li class="nav-item active">
          <a class="nav-link" href="#">Messages<span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Refresh</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" href="#">Currency</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" href="#">English</a>
        </li>
      </ul>
    </div>
  </nav>-->
  <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top navhome">
    <a class="navbar-brand" routerLink="" ><img src="https://vvdo-dev.vervendo.com/frontend/img/logo-2017-min.png" style="height: 70px;width:auto;"></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav btnav">
        <li class="nav-item active navli">
          <a class="nav-link nava" href="#">LogIn/SignUp<span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item navli">
          <a class="nav-link nava " href="#">Currency</a>
        </li>
        <li class="nav-item navli">
          <a class="nav-link nava" href="#">English</a>
        </li>
      </ul>
    </div>
  </nav>

  <div class="app-body homeback" style="margin-top:80px;">
    <main class="main">
      <!-- Main content here -->
      <div id="newWelcome">
        <!--<a href="https://youtu.be/Hz-8GAatc6E" target="_blank">Watch video</a>-->
      </div>
      <div id="newWelcomeLogo"></div>

    </main>
  </div>
</body>
